import React, { useState } from 'react'
import { Box, IconButton, Menu, MenuItem } from '@octanner/prism-core'
import { MenuDots } from '@octanner/prism-icons'

type MenuButtonProps = {
  onEditClick?: (state) => void
  onDeleteClick?: () => void
  isSuspended?: boolean
  onClickResumeGroup?: () => void
  onClickSuspendGroup?: () => void
  editButtonLabel?: string
}

const MenuButton = ({
  onEditClick,
  onDeleteClick,
  onClickResumeGroup,
  onClickSuspendGroup,
  isSuspended,
  editButtonLabel = 'Edit group',
}: MenuButtonProps) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const handleClick = (event: React.BaseSyntheticEvent) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <Box>
      <IconButton
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
        aria-label="celebration-level-menu"
      >
        <MenuDots />
      </IconButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {isSuspended && onClickResumeGroup ? (
          <>
            <MenuItem
              onClick={() => {
                onClickResumeGroup()
                handleClose()
              }}
            >
              Resume group
            </MenuItem>
          </>
        ) : (
          <>
            {onClickSuspendGroup && (
              <MenuItem onClick={onClickSuspendGroup}>Suspend group</MenuItem>
            )}
            {onEditClick && (
              <MenuItem
                onClick={(e) => {
                  onEditClick(e)
                  handleClose()
                }}
              >
                {editButtonLabel}
              </MenuItem>
            )}
            {onDeleteClick && (
              <MenuItem sx={{ color: 'red' }} onClick={onDeleteClick}>
                Delete
              </MenuItem>
            )}
          </>
        )}
      </Menu>
    </Box>
  )
}

export default MenuButton
